<template>
  <v-app>
    <div style="display: contents">
      <v-card
        flat
        width="100%"
        height="100%"
        class="d-flex justify-center align-center"
      >
        <v-card flat class="rounded-lg" width="350">
          <v-card-title class="pa-0">
            <v-form ref="form" class="px-4" style="width: 100%">
              <v-card-title class="justify-center align-center pt-0">
                <img src="@/assets/img/logo-survey.png" width="22%" />
                <v-toolbar-title
                  ><span
                    class="font-weight-bold"
                    style="color: #2d9ed7; font-size: 32px"
                    >Survey</span
                  ><span
                    class="font-weight-bold"
                    style="color: #f251a8; font-size: 32px"
                    >Me</span
                  ></v-toolbar-title
                >
              </v-card-title>
              <v-card-text
                v-if="timeout === 3601"
                class="d-flex justify-center"
              >
                <span
                  style="color: red; font-size: 16px;white-space: pre-line"
                  v-html="timeoutMsg"
                ></span>
              </v-card-text>
              <v-alert
                class="mx-6"
                border="right"
                colored-border
                v-if="alert"
                dense
                type="error"
                elevation="2"
                >รหัสผ่านหรือชื่อผู้ใช้ผิดพลาด</v-alert
              >
              <form @keyup.enter="functionlogin()">
                <v-row class="justify-center" no-gutters>
                  <v-col class="txtcol" cols="12" md="10">
                    <v-text-field
                      label="ชื่อผู้ใช้"
                      v-model="usernamelogin"
                      outlined
                      dense
                      class="rounded-lg"
                      color="#2B9DD7"
                      @click="alert = false"
                    >
                      <v-icon
                        outlined
                        slot="prepend-inner"
                        class="mr-3"
                        color="#2B9DD7"
                        >account_circle</v-icon
                      >
                    </v-text-field>
                  </v-col>
                  <v-col class="txtcol" cols="12" md="10">
                    <v-text-field
                      label="รหัสผ่าน"
                      v-model="passwordlogin"
                      outlined
                      dense
                      :type="!showPassword ? 'password' : 'text'"
                      class="rounded-lg"
                      color="#2B9DD7"
                      @click="alert = false"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showPassword = !showPassword"
                    >
                      <v-icon
                        outlined
                        slot="prepend-inner"
                        class="mr-3"
                        color="#2B9DD7"
                        >lock</v-icon
                      >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="10">
                    <v-btn
                      class="white--text rounded-lg"
                      color="#2B9DD7"
                      width="100%"
                      dense
                      v-on:click="functionlogin()"
                    >
                      เข้าสู่ระบบ
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    md="10"
                    align="center"
                    class="pt-2"
                    style=" font-size: 14px;"
                  >
                    <span style="color: rgba(0, 0, 0, 0.6); "
                      >ยังไม่มีบัญชีผู้ใช้ ?</span
                    >
                    <span
                      class="pl-4 text-decoration-underline"
                      style="color: #2B9DD7; cursor: pointer"
                      @click="register()"
                      >สมัครใช้งาน</span
                    >
                  </v-col>
                </v-row>
              </form>
              <!-- <v-card-subtitle class="text-center">หรือ </v-card-subtitle>
              <v-btn
                class="white--text"
                color="#033666"
                rounded
                dense
                block
                :href="onechatlogin"
              >
                เข้าสู่ระบบผ่าน ONEID
              </v-btn>
              <v-card-subtitle class="text-center"
                >คุณยังไม่มีบัญชี OneID ใช่หรือไม่ ?
              </v-card-subtitle>
              <v-btn
                color="#033666"
                block
                outlined
                rounded
                href="https://one.th/register"
                target="_blank"
                >ลงทะเบียน OneID</v-btn
              > -->
            </v-form>
          </v-card-title>
        </v-card>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import Swal from "sweetalert2";
export default {
  props: ["timeoutMsg", "timeout", "logged"],
  data: () => ({
    usernamelogin: "",
    passwordlogin: "",
    alert: false,
    showPassword: false,
    onechatlogin: process.env.VUE_APP_ONEID_LOGIN,
  }),
  mounted() {
    if (this.$route.query.code !== undefined) {
      // console.log(this.$route.query.code);
      this.$axios
        .post(process.env.VUE_APP_API_DOMAIN + "/CMUser/auth/LoginWithOneID", {
          code: this.$route.query.code,
          service: "CMSurvey",
          redirectUrl: process.env.VUE_APP_REDIRECT_ONEID,
        })
        .then((req) => {
          let apiTrial = {
            method: "get",
            url: `${process.env.VUE_APP_API}/manageSurvey/survey/trial`,
            data: {},
          };
          this.$axios({
            ...apiTrial,
            headers: {
              authorization: "Bearer " + req.data.accessToken,
            },
          }).then((trial) => {
            if (trial.data.ableTrial) {
              this.$store.commit("Login", req.data.accessToken);
              this.$cookies.set(
                process.env.VUE_APP_CM_AUTH_COOKIE + "_username",
                req.data.displayName
              );
              this.$emit("logged");
              if (this.$route.name !== "survey") {
                this.$router.push({
                  name: "survey",
                });
              }
            } else {
              let api = {
                method: "get",
                url: `${process.env.VUE_APP_API_DOMAIN}/CMSurvey/v3/manageAccount/checkPackage`,
                data: {},
              };
              this.$axios({
                ...api,
                headers: {
                  authorization: "Bearer " + req.data.accessToken,
                },
              }).then((allowUser) => {
                // console.log(allowUser);
                if (
                  allowUser.data.typeUser === "AvailableUser" ||
                  allowUser.data.typeUser === "MemberUser"
                ) {
                  this.$store.commit("Login", req.data.accessToken);
                  this.$cookies.set(
                    process.env.VUE_APP_CM_AUTH_COOKIE + "_username",
                    req.data.displayName
                  );
                  this.$emit("logged");
                  if (this.$route.name !== "survey") {
                    this.$router.push({
                      name: "survey",
                    });
                  }
                } else {
                  this.NotAllowAlert(allowUser);
                }
              });
            }
          });
        })
        .catch((error) => {
          if (!error.response) {
            Swal.fire({
              html: `
            ระบบมีปัญหาเกี่ยวกับ server ไม่สามารถใช้งานได้ในขณะนี้
            <br>ขออภัยในความไม่สะดวก
            <br><br>สามารถติดต่อทีมงานได้ที่<br><a style="color: #0093cc;"
                href='tel:0935781416'
                >093-5781416</a
              >, <a style="color: #0093cc;"
              href='tel:0655214474'
              >065-5214474</a
            >, <a style="color: #033666;"
            href='tel:0655214459'
            >065-5214459</a
          >`,
              icon: "error",
              showCancelButton: false,
              showConfirmButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              confirmButtonColor: "#0093cc",
              confirmButtonText: "รับทราบ",
            });
          } else {
            if (!error.response.data.auth) {
              if (error.response.data.message === "Token not match.") {
                Swal.fire({
                  html: `พบการ login ซ้ำ`,
                  icon: "warning",
                  showCancelButton: false,
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  allowEnterKey: false,
                  confirmButtonColor: "#0093cc",
                  confirmButtonText: "รับทราบ",
                });
              }
            } else {
              this.alert = true;
            }
          }
        });
    }
  },
  methods: {
    NotAllowAlert(allowUser) {
      let text = "ระบบมีปัญหา กรุณาติดต่อทีมงาน";
      if (allowUser.data.typeUser === "ExpiredUser") {
        text = `Package ของคุณหมดอายุ<br>กรุณาติดต่อทีมงานเพื่อขอต่ออายุบริการได้ที่<br><a style="color: #0093cc;"
                      href='tel:0935781416'
                      >093-5781416</a
                    >, <a style="color: #0093cc;"
                    href='tel:0655214474'
                    >065-5214474</a
                  >, <a style="color: #033666;"
            href='tel:0655214459'
            >065-5214459</a
          >`;
      } else if (allowUser.data.typeUser === "NotStartUser") {
        text = `บัญชีของคุณยังไม่สามารถใช้งานได้ จะสามารถใช้งานได้ตั้งแต่วันที่ ${this.$store.getters.dateConvertVeryShort(
          allowUser.data.startedDate
        )} เป็นต้นไป<br>สอบถามข้อมูลเพิ่มเติมได้ที่<br><a style="color: #0093cc;"
                      href='tel:0935781416'
                      >093-5781416</a
                    >, <a style="color: #0093cc;"
                    href='tel:0655214474'
                    >065-5214474</a
                  >, <a style="color: #033666;"
            href='tel:0655214459'
            >065-5214459</a
          >`;
      }
      Swal.fire({
        html: text,
        icon: "warning",
        showCancelButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        confirmButtonColor: "#0093cc",
        confirmButtonText: "ตกลง",
      });
    },
    functionlogin() {
      this.$axios
        .post(process.env.VUE_APP_API_DOMAIN + "/CMUser/auth/Login", {
          username: this.usernamelogin,
          password: this.passwordlogin,
        })
        .then((req) => {
          let apiTrial = {
            method: "get",
            url: `${process.env.VUE_APP_API}/manageSurvey/survey/trial`,
            data: {},
          };
          this.$axios({
            ...apiTrial,
            headers: {
              authorization: "Bearer " + req.data.accessToken,
            },
          }).then((trial) => {
            if (trial.data.ableTrial) {
              this.$store.state.loading = false
              this.$store.commit("Login", req.data.accessToken);
              this.$cookies.set(
                process.env.VUE_APP_CM_AUTH_COOKIE + "_username",
                req.data.displayName
              );
              this.$emit("logged");
              if (this.$route.name !== "survey") {
                this.$router.push({
                  name: "survey",
                });
              }
            } else {
              let api = {
                method: "get",
                url: `${process.env.VUE_APP_API_DOMAIN}/CMSurvey/v3/manageAccount/checkPackage`,
                data: {},
              };
              this.$axios({
                ...api,
                headers: {
                  authorization: "Bearer " + req.data.accessToken,
                },
              }).then((allowUser) => {
                // console.log(allowUser);
                if (
                  allowUser.data.typeUser === "AvailableUser" ||
                  allowUser.data.typeUser === "MemberUser"
                ) {
                  this.$store.state.loading = false
                  this.$store.commit("Login", req.data.accessToken);
                  this.$cookies.set(
                    process.env.VUE_APP_CM_AUTH_COOKIE + "_username",
                    req.data.displayName
                  );
                  this.$emit("logged");
                  if (this.$route.name !== "survey") {
                    this.$router.push({
                      name: "survey",
                    });
                  }
                } else {
                  this.NotAllowAlert(allowUser);
                }
              });
            }
          });
        })
        .catch((error) => {
          if (!error.response) {
            Swal.fire({
              html: `
            ระบบมีปัญหาเกี่ยวกับ server ไม่สามารถใช้งานได้ในขณะนี้
            <br>ขออภัยในความไม่สะดวก
            <br><br>สามารถติดต่อทีมงานได้ที่<br><a style="color: #0093cc;"
                href='tel:0935781416'
                >093-5781416</a
              >, <a style="color: #0093cc;"
              href='tel:0655214474'
              >065-5214474</a
            >, <a style="color: #033666;"
            href='tel:0655214459'
            >065-5214459</a
          >
`,
              icon: "error",
              showCancelButton: false,
              showConfirmButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              confirmButtonColor: "#0093cc",
              confirmButtonText: "รับทราบ",
            });
          } else {
            if (!error.response.data.auth) {
              if (error.response.data.message === "Token not match.") {
                Swal.fire({
                  html: `พบการ login ซ้ำ`,
                  icon: "warning",
                  showCancelButton: false,
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  allowEnterKey: false,
                  confirmButtonColor: "#0093cc",
                  confirmButtonText: "รับทราบ",
                });
              } else {
                this.alert = true;
              }
            } else {
              this.alert = true;
            }
          }
        });
    },
    register() {
      this.$router.push({ path: "/register" });
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: "MitrRegular";
  src: url("~@/assets/font/MitrRegular/MitrRegular.ttf");
}
#app {
  font-family: "MitrRegular" !important;
}
.v-input >>> .v-label--active {
  left: -40px !important;
}
</style>
